<template>
    <div>
        <div class="content-page" v-if=storedStatusJWT>
            <h2 class="text-center pt2 pb-4">Статистика</h2>
            <div class="align-content-center text-center">
                <template>
                    <div class="text-center">
                        <b-table responsive striped hover :items="items" :tbody-tr-class="rowClass"></b-table>
                        <div class="my-1 col-md-3 float-right">
                            <ul role="menubar" aria-disabled="false" aria-label="Pagination"
                                class="pagination my-0 b-pagination pagination-sm text-center">
                                <li role="presentation" class="page-item flex-fill d-flex">
                                    <button :disabled="page <= 0" @click="paginator('pre')" role="menuitem" type="button" tabindex="-1" aria-label="Go to next page" class="page-link flex-grow-1">‹‹</button>
                                </li>
                                <li role="presentation" class="page-item flex-fill d-flex">
                                    <button :disabled="this.countRow < 10" @click="paginator('after')" role="menuitem" type="button" tabindex="-1" aria-label="Go to next page" class="page-link flex-grow-1">››</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from "./Login";
import Cookies from "js-cookie";
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        items: [],
        pp: "сумма пополнения",
        page: 0,
        countRow: 0
    }),
    created() {
        if (this.storedStatusJWT) {
            this.axios
                .get('/api/statistics/0')
                .then(response => {
                    this.countRow = Object.values(response.data).length;
                    this.items = response.data;
                })
        } else {
            window.location.href = '/home';
        }
    },
    components: {LoginForm},
    methods: {
        logout: function () {
            Cookies.remove('JWT');
            window.location.href = "/home/";
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item[this.pp] > 0) return 'table-success'
        },
        paginator(type){
            if (type === "pre"){
                this.page--
            } else {
                this.page++
            }
            this.axios
                .get('/api/statistics/' + this.page)
                .then(response => {
                    this.items = response.data;
                    this.countRow = Object.values(response.data).length;
                })
        },
    },
    computed: {
        ...mapGetters([
            'storedStatusJWT'
        ])
    },
}
</script>
<style>

.card-deck .card {
    box-shadow: 1px 5px 5px #dae0e5;
}

.card-deck {
    margin-right: 1px;
    margin-left: 1px;
}
</style>
